import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_1: FaireProductEntity = {
  token: "plant-dyed-1",
  type: "product",
  name: "Plant & mineral dyed cotton napkin",
  brandName: "Ichcha",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/194541a571ded66fbe2cbeb4a4199500b4e4b8221006e4f808c516d82d5eca78.png",
  priceDollars: 2.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/194541a571ded66fbe2cbeb4a4199500b4e4b8221006e4f808c516d82d5eca78.png",
  weight: 0.2,
  dimensions: {
    width: 12,
    height: 12,
    depth: 0.5,
  },
  description: "Plant and mineral dyed cotton napkin with natural colors",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "cotton",
    "napkin",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
